import React, { useEffect, useRef, useState } from 'react';

/**
 * Defers mounting `children` until the wrapped element scrolls near the
 * viewport. Used for heavy below-the-fold widgets (e.g. the world map, which
 * pulls in react-simple-maps/d3-geo and fetches an external topojson file)
 * so their JS/network cost isn't paid on initial page load.
 */
const LazyOnVisible = ({ children, minHeight = 400, rootMargin = '200px' }) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (visible || typeof IntersectionObserver === 'undefined') {
      setVisible(true);
      return;
    }
    const node = ref.current;
    if (!node) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin }
    );
    observer.observe(node);
    return () => observer.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div ref={ref} style={visible ? undefined : { minHeight }}>
      {visible ? children : null}
    </div>
  );
};

export default LazyOnVisible;
